import { Widget, TimelineSlot, WidgetState } from './index';
import { Scheduler, SchedulerItem } from '../Utility/Scheduler';

/**
 * Widget with Scheduler
 */
export abstract class WidgetWithScheduler extends Widget {
    /**
     * Name of this widget's Scheduler
     */
    protected get schedulerName(): string {
        return `get_${this.type}_${this.id}`;
    }

    /**
     * @todo: should make this abstract
     * Number of seconds between each time the `Scheduler` runs
     */
    protected schedulerRunInterval = 900; //15 minutes

    /**
     * Handler used to Pause/Resume Scheduler
     */
    protected schedulerHandle: null | SchedulerItem = null;

    async pause(currentSlot: TimelineSlot): Promise<void> {
        if (this.state === WidgetState.PLAYING) {
            this.pauseScheduler();
        }
        await super.pause(currentSlot);
    }

    async play(currentSlot: TimelineSlot): Promise<void> {
        this.startScheduler();
        await super.play(currentSlot);
    }

    async stop(): Promise<void> {
        this.stopScheduler();
        await super.stop();
    }

    /**
     * Scheduler Action
     */
    abstract schedulerAction(): Promise<void> | void;

    /**
     * Start Scheduler that updates widget content
     */
    startScheduler(): void {
        if (this.schedulerHandle) {
            this.schedulerHandle.Resume();
        } else {
            this.schedulerHandle = Scheduler.New()
                .Called(this.schedulerName)
                .HasAction(this.schedulerAction.bind(this))
                .RunEvery(this.schedulerRunInterval, 'seconds');
        }
    }

    /**
     * Pause Scheduler that updates widget content
     */
    pauseScheduler(): void {
        if (this.schedulerHandle) {
            this.schedulerHandle.Pause();
        }
    }

    /**
     * Stop Scheduler that updates widget content
     */
    stopScheduler(): void {
        Scheduler.Delete(this.schedulerName);
        this.schedulerHandle = null;
    }
}
